import InfoCard from 'common/ui/info-card';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';

const ItemDetail = ({ item }) => {
  const { created_at, province_id, id, name, updated_at } = item || {};

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        {/* Basic Information */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <InfoCard label="ID" value={id} />
          <InfoCard label="Name" value={name} />
          <InfoCard
            label="Province ID"
            value={
              <Link to={`/admin/provinces/${province_id}`}>
                {province_id}
              </Link>
            }
          />
        </div>
      </div>

      {/* Metadata Section */}
      <div className="bg-gray-50 -mx-6 -mb-6 p-6 rounded-b-lg mt-4 space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <InfoCard label="Created At" value={formatDateTime(created_at)} />
          <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
        </div>
      </div>
    </div>
  );
};

export default ItemDetail;
